import React from 'react';
import styled from 'styled-components';
import Carousel from './Carousel';
import Creator from './Creator'
import CustomizationPortal from './CustomizationPortal';
import CustomizationWrapper from './CustomizationWrapper';
import './../styles/App.css';
import './../styles/style.scss';
import Helper from '../classes/Helper';
import Api from '../classes/Api';

const CarouselWrapper = styled.div`
  display: flex;
  max-width: 100%;
  max-height: 100%;
`;
export default class App extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      projectsCount: window.json_projects.length,
      clientCustomizationVisibility: false,
      thumbnailItems: [],
      items: [],
      carouselSwiper: undefined
    };

    this.prepareData();
  }

  prepareData = (e) => {
    Object.keys(window.thumbnails).map((key) => {
        if(!window.thumbnails[key].creator){
          this.state.items.push(<img src={window.thumbnails[key].large.url}/>);
          this.state.thumbnailItems.push(<img src={window.thumbnails[key].large.url}/>);
        }
      }
    );

    window.json_projects.map((project, index) => {
      this.state.thumbnailItems.push(
          <img src='' id={`konvaThumb${index}`}></img>
      );
    });

    window.json_projects.map((project, index) => {
        this.state.items.push(
          <Creator
            project={project}
            index={index}
            setClientCustomizationVisible={this.setClientCustomizationVisible}
          />
        );
        project.slideIndex = this.state.items.length - 1;
    });
    this.forceUpdate();
  }

  setClientCustomizationVisible = () => {
    this.setState({
      clientCustomizationVisibility: true
    });
  }

  setCarouselSwiper = (carouselSwiper) => {
    this.setState({
      carouselSwiper: carouselSwiper
    });
  }

  replaceProject = (object, newProjectId, callback) => {
    Api.getProject(newProjectId)
    .then(data => data.json())
    .then(json => {
      json.forEach((jsonItem) => {
        if(jsonItem.id_project === newProjectId){
          window.json_projects.forEach((projectItem, projectKey) => {
            projectItem.creator_data = projectItem.stage.toObject();
            if(projectItem.id_project === object.id_project){
              Helper.extend(projectItem, jsonItem)
              this.setState({
                thumbnailItems: [],
                items: [],
                setClientCustomizationVisible: false,
              }, () => {
                this.prepareData();
                setTimeout(() => {
                  callback();
                }, 500);
              })
            }
          })
        }
      })
    })
  }
  
  render(){
    const { 
      clientCustomizationVisibility, projectsCount, 
      thumbnailItems, items, carouselSwiper } = this.state;

    return(
      <>
        { items.length > 0 &&
          <CarouselWrapper>
            <Carousel
              thumbnailItems={thumbnailItems}
              items={items}
              projectsCount={projectsCount}
              setCarouselSwiper={this.setCarouselSwiper}
            />
          </CarouselWrapper>
        }
        {
          clientCustomizationVisibility && 
          <CustomizationPortal
            children={ 
              <CustomizationWrapper
                projects={window.json_projects}
                replaceProject={this.replaceProject}
                carouselSwiper={carouselSwiper}
              /> 
            }
          /> 
        }
      </>
      )
    }
}